import { render, staticRenderFns } from "./InstanceEditMail.vue?vue&type=template&id=f3fdc37c&scoped=true&"
import script from "./InstanceEditMail.vue?vue&type=script&lang=js&"
export * from "./InstanceEditMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fdc37c",
  null
  
)

export default component.exports